// Colours of the marks the floor plan draws while a wall-length edit is
// previewed. The canvas (useFloorplanRenderer) and the Measurement panel's key
// (StretchPreviewKey) both read them, so the key's swatches are always the
// colours actually on screen.
export const STRETCH_PREVIEW_COLORS = {
  // The translate-rectangle: what moves with the wall.
  region: '#7c3aed',
  regionFill: 'rgba(124, 58, 237, 0.07)',
  // Ghost of the old position of every wall that moved or stretched.
  ghost: 'rgba(167, 139, 250, 0.55)',
  // Dashed overlay on walls whose length changes (HIGHLIGHT_COLORS.PREVIEW).
  resized: '#ff8c00',
};
